/** Opens the command palette, as pressing ⌘K does: its listener takes the same keydown. */
export const openCommandPalette = () => {
  document.dispatchEvent(new KeyboardEvent("keydown", { bubbles: true, key: "k", metaKey: true }));
};
